<div class="header">
  <h2>{{ "pages.tutors.title" | translate }}</h2>
</div>

<div class="search">
  <div class="search-field-wrapper" alAnchor="agents.search">
    <app-search-input
      [(value)]="searchText"
      (valueChange)="onSearchChange()"
    ></app-search-input>
  </div>

  <div class="actions-right">
  <nb-select
    class="template-filter"
    alAnchor="agents.template-filter"
    [(selected)]="selectedTemplateFilter"
    [placeholder]="'pages.tutors.filter.label' | translate"
    size="medium"
  >
    <nb-option value="all">{{ 'pages.tutors.filter.allTemplates' | translate }}</nb-option>
    <nb-option *ngFor="let t of availableTemplates" [value]="t.id">
      {{ "enums.assistantTemplate." + t.name | translate }}
    </nb-option>
  </nb-select>

  <nb-select
    *ngIf="canFilterByUser && users.length"
    class="template-filter"
    [selected]="selectedUserFilter"
    (selectedChange)="onUserFilterChange($event)"
    [placeholder]="'pages.tutors.filter.userLabel' | translate"
    size="medium"
  >
    <nb-option value="all">{{ 'pages.tutors.filter.allUsers' | translate }}</nb-option>
    <nb-option *ngFor="let u of users" [value]="u.id">{{ u.name }}</nb-option>
  </nb-select>

  <nb-button-group (valueChange)="onCardSizeSelect($event)">
    <button [pressed]="cardSize === 'small'" nbButtonToggle value="small" title="Kleine Kacheln">
      <svg viewBox="0 0 18 18" width="16" height="16" fill="currentColor">
        <rect x="0" y="0" width="5" height="5" rx="0.5"/>
        <rect x="6.5" y="0" width="5" height="5" rx="0.5"/>
        <rect x="13" y="0" width="5" height="5" rx="0.5"/>
        <rect x="0" y="6.5" width="5" height="5" rx="0.5"/>
        <rect x="6.5" y="6.5" width="5" height="5" rx="0.5"/>
        <rect x="13" y="6.5" width="5" height="5" rx="0.5"/>
        <rect x="0" y="13" width="5" height="5" rx="0.5"/>
        <rect x="6.5" y="13" width="5" height="5" rx="0.5"/>
        <rect x="13" y="13" width="5" height="5" rx="0.5"/>
      </svg>
    </button>
    <button [pressed]="cardSize === 'large'" nbButtonToggle value="large" title="Große Kacheln">
      <svg viewBox="0 0 18 18" width="16" height="16" fill="currentColor">
        <rect x="0" y="0" width="8" height="8" rx="0.5"/>
        <rect x="10" y="0" width="8" height="8" rx="0.5"/>
        <rect x="0" y="10" width="8" height="8" rx="0.5"/>
        <rect x="10" y="10" width="8" height="8" rx="0.5"/>
      </svg>
    </button>
  </nb-button-group>

  <button nbButton status="primary" appearance="outline" (click)="onEmbedChat()" alAnchor="agents.embed">
    <nb-icon icon="code-outline"></nb-icon> {{ "buttons.embed" | translate }}
  </button>

  <button
    nbButton
    status="primary"
    appearance="outline"
    (click)="onAddTutor()"
    alAnchor="agents.create"
    alNotes="addAssistentButton"
    [alNotesIsVisible]="!isLoading && tutorService.tutors$.value.length === 0"
  >
    <nb-icon icon="plus"></nb-icon>{{ "buttons.add" | translate }}
  </button>

  @if(chatPreviewService.isChatActive$.value === false){
  <button class="start-tutor-btn" (click)="onStartChat()">
    <div class="points_wrapper">
      <i class="point"></i><i class="point"></i><i class="point"></i><i class="point"></i><i class="point"></i>
      <i class="point"></i><i class="point"></i><i class="point"></i><i class="point"></i><i class="point"></i>
    </div>
    <span class="inner">
      {{ "components.dashboardHeader.startTutor" | translate }}
      <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <path d="M5 12h14"></path>
        <path d="m12 5 7 7-7 7"></path>
      </svg>
    </span>
  </button>
  } @else {
  <button nbButton status="danger" size="medium" (click)="onCloseChat()">
    {{ "components.dashboardHeader.stopTutor" | translate }}
  </button>
  }
  </div>
</div>

<ng-container *ngIf="!isLoading; else loader">
  <ng-container *ngIf="tutorSections.length; else emptyState">
    <section
      class="template-section"
      *ngFor="let section of tutorSections; trackBy: trackTutorSection"
    >
      <header class="template-section__header">
        <h4>{{ "enums.assistantTemplate." + section.template.name | translate }}</h4>
      </header>

      <div class="card-grid {{ cardSize }}" alAnchor="agents.grid">
        <app-tutor-card
          *ngFor="let t of section.tutors; trackBy: trackTutor"
          [tutor]="t"
          [agentTarget]="['bot', t.id, 'card']"
          [alAnchor]="'agentcard.' + section.template.name"
          [activeUsers]="getActiveUsers(t.id)"
          [size]="cardSize"
        ></app-tutor-card>
      </div>
    </section>
  </ng-container>

  <ng-template #emptyState>
    <p class="empty-state">{{ 'pages.tutors.noAgents' | translate }}</p>
  </ng-template>
</ng-container>

<ng-template #loader>
  <app-page-loader></app-page-loader>
</ng-template>
